module.exports = __webpack_public_path__ + "img/logo-update-new.2a824f31.png";